import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  position: relative;
  padding: 20px 0px;
`;

export default Container;
